import { jsx } from '@emotion/react/jsx-runtime';
import { useMemo } from 'react';
import { ThemeProvider as ThemeProvider$1, useTheme, css, Global } from '@emotion/react';
export { css } from '@emotion/react';

var theme = {
    colors: {
        common: {
            black: '#000',
            white: '#fff',
        },
        primary: {
            100: '#E6EAF7',
            200: '#BFCBEC',
            300: '#8098D8',
            400: '#4064C5',
            500: '#0031B2',
            600: '#002A97',
            700: '#00227D',
            800: '#001B62',
            900: '#001447',
        },
        secondary: {
            100: '#FCE6E6',
            200: '#FACCCC',
            300: '#F7B3B3',
            400: '#F59999',
            500: '#F28080',
            600: '#CE6D6D',
            700: '#A95A5A',
            800: '#854646',
            900: '#613333',
        },
        success: {
            100: '#D9F7E7 ',
            200: '#BBF1D4',
            300: '#8CE7B6',
            400: '#5DDE98',
            500: '#2ED47A',
            600: '#27B468',
            700: '#209455',
            800: '#197543',
            900: '#125531',
        },
        danger: {
            100: '#FEE6E6',
            200: '#FDC6C6',
            300: '#FA8C8C',
            400: '#F86666',
            500: '#F64040',
            600: '#D13636',
            700: '#AC2D2D',
            800: '#872323',
            900: '#621A1A',
        },
        warning: {
            100: '#FFE9C6 ',
            200: '#FFDA9C',
            300: '#FFC76B',
            400: '#FFB539',
            500: '#FFA208',
            600: '#D98A07',
            700: '#B37106',
            800: '#8C5904',
            900: '#664103',
        },
        info: {
            100: '#DBF0FD ',
            200: '#B1DFFA',
            300: '#7CC9F7',
            400: '#46B2F4',
            500: '#109CF1',
            600: '#0E85CD',
            700: '#0B6DA9',
            800: '#095685',
            900: '#063E60',
        },
        neutral: {
            100: '#EDEDEF',
            200: '#D1D3D7',
            300: '#B0B4BB',
            400: '#90959F',
            500: '#707683',
            600: '#5F646F',
            700: '#4E535C',
            800: '#3E4148',
            900: '#2D2F34',
        },
        extra: {
            background: '#FFFFFA',
            disabled_bg: '#DADEE2',
            disabled_font: '#BDBCBC',
            gray_style: '#FAFAFC',
            gray_icon: '#90A0B7',
        },
    },
    shadows: [
        '0px 2px 6px rgba(0, 0, 0, 0.1)',
        '6px 6px 12px rgba(0, 0, 0, 0.08)',
        '0px 12px 18px rgba(0, 0, 0, 0.1)',
        '0px 10px 24px rgba(0, 0, 0, 0.1)',
    ],
    borderRadius: {
        none: '0px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        pill: '500px',
        circular: '50%',
    },
    borderWidths: {
        none: '0px',
        hairline: '1px',
        thin: '2px',
        thick: '4px',
        heavy: '8px',
    },
    spacing: function (value) { return value * 8; },
    typography: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeighSemiBold: 600,
        fontWeightBold: 700,
        fontWeightExtraBold: 800,
        fontWeightBlack: 900,
        h0: {
            fontFamily: '"Lato", "Nunito", sans-serif',
            fontSize: '48px',
            fontWeight: 900,
            letterSpacing: '0',
            lineHeight: '64px',
        },
        h1: {
            fontFamily: '"Lato", "Nunito", sans-serif',
            fontSize: '32px',
            fontWeight: 800,
            letterSpacing: '0',
            lineHeight: '48px',
        },
        h2: {
            fontFamily: '"Lato", "Nunito", sans-serif',
            fontSize: '24px',
            fontWeight: 700,
            letterSpacing: '0',
            lineHeight: '40px',
        },
        h3: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '20px',
            fontWeight: 700,
            letterSpacing: '0',
            lineHeight: '28px',
        },
        h4: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '18px',
            fontWeight: 600,
            letterSpacing: '0',
            lineHeight: '26px',
        },
        h5: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '16px',
            fontWeight: 600,
            letterSpacing: '0',
            lineHeight: '24px',
        },
        body1: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '16px',
            fontWeight: 400,
            letterSpacing: '0',
            lineHeight: '24px',
        },
        body2: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0',
            lineHeight: '22px',
        },
        button1: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 700,
            letterSpacing: '0.1rem',
            lineHeight: '24px',
        },
        button2: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '16px',
            fontWeight: 700,
            letterSpacing: '0.01rem',
            lineHeight: '24px',
        },
        button3: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 700,
            letterSpacing: '0.01rem',
            lineHeight: '24px',
        },
        link: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '0.01rem',
            lineHeight: '24px',
        },
        label: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0',
            lineHeight: '22px',
        },
        microCopy: {
            fontFamily: '"Nunito", sans-serif',
            fontSize: '12px',
            fontWeight: 400,
            letterSpacing: '0',
            lineHeight: '20px',
        },
    },
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var objIsEmpty = function (obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};

// TODO: adicionar um segundo contexto e provider envolvendo o EmotionThemeProvider para passar um setter para o theme via context api
var ThemeProvider = function (_a) {
    var children = _a.children, theme$1 = _a.theme;
    return (jsx(ThemeProvider$1, __assign({ theme: theme$1 || theme }, { children: children })));
};
var useThemeContext = function () {
    var contextTheme = useTheme();
    var theme$1 = useMemo(function () { return (!objIsEmpty(contextTheme) ? contextTheme : theme); }, [contextTheme]);
    return theme$1;
};

var toString = Object.prototype.toString;

var kindOf = function kindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';

  var type = typeof val;
  if (type === 'boolean') return 'boolean';
  if (type === 'string') return 'string';
  if (type === 'number') return 'number';
  if (type === 'symbol') return 'symbol';
  if (type === 'function') {
    return isGeneratorFn(val) ? 'generatorfunction' : 'function';
  }

  if (isArray(val)) return 'array';
  if (isBuffer(val)) return 'buffer';
  if (isArguments(val)) return 'arguments';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  if (isRegexp(val)) return 'regexp';

  switch (ctorName(val)) {
    case 'Symbol': return 'symbol';
    case 'Promise': return 'promise';

    // Set, Map, WeakSet, WeakMap
    case 'WeakMap': return 'weakmap';
    case 'WeakSet': return 'weakset';
    case 'Map': return 'map';
    case 'Set': return 'set';

    // 8-bit typed arrays
    case 'Int8Array': return 'int8array';
    case 'Uint8Array': return 'uint8array';
    case 'Uint8ClampedArray': return 'uint8clampedarray';

    // 16-bit typed arrays
    case 'Int16Array': return 'int16array';
    case 'Uint16Array': return 'uint16array';

    // 32-bit typed arrays
    case 'Int32Array': return 'int32array';
    case 'Uint32Array': return 'uint32array';
    case 'Float32Array': return 'float32array';
    case 'Float64Array': return 'float64array';
  }

  if (isGeneratorObj(val)) {
    return 'generator';
  }

  // Non-plain objects
  type = toString.call(val);
  switch (type) {
    case '[object Object]': return 'object';
    // iterators
    case '[object Map Iterator]': return 'mapiterator';
    case '[object Set Iterator]': return 'setiterator';
    case '[object String Iterator]': return 'stringiterator';
    case '[object Array Iterator]': return 'arrayiterator';
  }

  // other
  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
};

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isArray(val) {
  if (Array.isArray) return Array.isArray(val);
  return val instanceof Array;
}

function isError(val) {
  return val instanceof Error || (typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number');
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function'
    && typeof val.getDate === 'function'
    && typeof val.setDate === 'function';
}

function isRegexp(val) {
  if (val instanceof RegExp) return true;
  return typeof val.flags === 'string'
    && typeof val.ignoreCase === 'boolean'
    && typeof val.multiline === 'boolean'
    && typeof val.global === 'boolean';
}

function isGeneratorFn(name, val) {
  return ctorName(name) === 'GeneratorFunction';
}

function isGeneratorObj(val) {
  return typeof val.throw === 'function'
    && typeof val.return === 'function'
    && typeof val.next === 'function';
}

function isArguments(val) {
  try {
    if (typeof val.length === 'number' && typeof val.callee === 'function') {
      return true;
    }
  } catch (err) {
    if (err.message.indexOf('callee') !== -1) {
      return true;
    }
  }
  return false;
}

/**
 * If you need to support Safari 5-7 (8-10 yr-old browser),
 * take a look at https://github.com/feross/is-buffer
 */

function isBuffer(val) {
  if (val.constructor && typeof val.constructor.isBuffer === 'function') {
    return val.constructor.isBuffer(val);
  }
  return false;
}

/*!
 * shallow-clone <https://github.com/jonschlinkert/shallow-clone>
 *
 * Copyright (c) 2015-present, Jon Schlinkert.
 * Released under the MIT License.
 */

const valueOf = Symbol.prototype.valueOf;


function clone(val, deep) {
  switch (kindOf(val)) {
    case 'array':
      return val.slice();
    case 'object':
      return Object.assign({}, val);
    case 'date':
      return new val.constructor(Number(val));
    case 'map':
      return new Map(val);
    case 'set':
      return new Set(val);
    case 'buffer':
      return cloneBuffer(val);
    case 'symbol':
      return cloneSymbol(val);
    case 'arraybuffer':
      return cloneArrayBuffer(val);
    case 'float32array':
    case 'float64array':
    case 'int16array':
    case 'int32array':
    case 'int8array':
    case 'uint16array':
    case 'uint32array':
    case 'uint8clampedarray':
    case 'uint8array':
      return cloneTypedArray(val);
    case 'regexp':
      return cloneRegExp(val);
    case 'error':
      return Object.create(val);
    default: {
      return val;
    }
  }
}

function cloneRegExp(val) {
  const flags = val.flags !== void 0 ? val.flags : (/\w+$/.exec(val) || void 0);
  const re = new val.constructor(val.source, flags);
  re.lastIndex = val.lastIndex;
  return re;
}

function cloneArrayBuffer(val) {
  const res = new val.constructor(val.byteLength);
  new Uint8Array(res).set(new Uint8Array(val));
  return res;
}

function cloneTypedArray(val, deep) {
  return new val.constructor(val.buffer, val.byteOffset, val.length);
}

function cloneBuffer(val) {
  const len = val.length;
  const buf = Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : Buffer.from(len);
  val.copy(buf);
  return buf;
}

function cloneSymbol(val) {
  return valueOf ? Object(valueOf.call(val)) : {};
}

/**
 * Expose `clone`
 */

var shallowClone = clone;

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

var isobject = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



function isObjectObject(o) {
  return isobject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

var isPlainObject = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};

/**
 * Module dependenices
 */





function cloneDeep(val, instanceClone) {
  switch (kindOf(val)) {
    case 'object':
      return cloneObjectDeep(val, instanceClone);
    case 'array':
      return cloneArrayDeep(val, instanceClone);
    default: {
      return shallowClone(val);
    }
  }
}

function cloneObjectDeep(val, instanceClone) {
  if (typeof instanceClone === 'function') {
    return instanceClone(val);
  }
  if (instanceClone || isPlainObject(val)) {
    const res = new val.constructor();
    for (let key in val) {
      res[key] = cloneDeep(val[key], instanceClone);
    }
    return res;
  }
  return val;
}

function cloneArrayDeep(val, instanceClone) {
  const res = new val.constructor(val.length);
  for (let i = 0; i < val.length; i++) {
    res[i] = cloneDeep(val[i], instanceClone);
  }
  return res;
}

/**
 * Expose `cloneDeep`
 */

var cloneDeep_1 = cloneDeep;

function makeStyles(styles) {
    var useStyles = function (styleProps) {
        var theme = useThemeContext();
        var currStyles = useMemo(function () {
            var _a;
            var stylesClone = cloneDeep_1(styles);
            var processedStyles = {};
            for (var _i = 0, _b = Object.entries(stylesClone); _i < _b.length; _i++) {
                var _c = _b[_i], key = _c[0], styleOrCreator = _c[1];
                Object.assign(processedStyles, (_a = {},
                    _a[key] = typeof styleOrCreator === 'function'
                        ? styleOrCreator(theme, styleProps)
                        : styleOrCreator,
                    _a));
            }
            return processedStyles;
        }, [styleProps, theme]);
        return currStyles;
    };
    return useStyles;
}

var reset = css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  html,\n  body,\n  div,\n  span,\n  applet,\n  object,\n  iframe,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  blockquote,\n  pre,\n  a,\n  abbr,\n  acronym,\n  address,\n  big,\n  cite,\n  code,\n  del,\n  dfn,\n  em,\n  img,\n  ins,\n  kbd,\n  q,\n  s,\n  samp,\n  small,\n  strike,\n  strong,\n  sub,\n  sup,\n  tt,\n  var,\n  b,\n  u,\n  i,\n  center,\n  dl,\n  dt,\n  dd,\n  ol,\n  ul,\n  li,\n  fieldset,\n  form,\n  label,\n  legend,\n  table,\n  caption,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td,\n  article,\n  aside,\n  canvas,\n  details,\n  embed,\n  figure,\n  figcaption,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  output,\n  ruby,\n  section,\n  summary,\n  time,\n  mark,\n  audio,\n  video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n  article,\n  aside,\n  details,\n  figcaption,\n  figure,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  section {\n    display: block;\n  }\n  body {\n    line-height: 1;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  blockquote,\n  q {\n    quotes: none;\n  }\n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: '';\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n"], ["\n  html,\n  body,\n  div,\n  span,\n  applet,\n  object,\n  iframe,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  blockquote,\n  pre,\n  a,\n  abbr,\n  acronym,\n  address,\n  big,\n  cite,\n  code,\n  del,\n  dfn,\n  em,\n  img,\n  ins,\n  kbd,\n  q,\n  s,\n  samp,\n  small,\n  strike,\n  strong,\n  sub,\n  sup,\n  tt,\n  var,\n  b,\n  u,\n  i,\n  center,\n  dl,\n  dt,\n  dd,\n  ol,\n  ul,\n  li,\n  fieldset,\n  form,\n  label,\n  legend,\n  table,\n  caption,\n  tbody,\n  tfoot,\n  thead,\n  tr,\n  th,\n  td,\n  article,\n  aside,\n  canvas,\n  details,\n  embed,\n  figure,\n  figcaption,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  output,\n  ruby,\n  section,\n  summary,\n  time,\n  mark,\n  audio,\n  video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n  article,\n  aside,\n  details,\n  figcaption,\n  figure,\n  footer,\n  header,\n  hgroup,\n  menu,\n  nav,\n  section {\n    display: block;\n  }\n  body {\n    line-height: 1;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  blockquote,\n  q {\n    quotes: none;\n  }\n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: '';\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n"])));
var templateObject_1$3;

var normalize = css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  html {\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n  }\n  body {\n    margin: 0;\n  }\n  main {\n    display: block;\n  }\n  h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n  }\n  hr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n  }\n  pre {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n  a {\n    background-color: transparent;\n  }\n  abbr[title] {\n    border-bottom: none;\n    text-decoration: underline;\n    text-decoration: underline dotted;\n  }\n  b,\n  strong {\n    font-weight: bolder;\n  }\n  code,\n  kbd,\n  samp {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n  small {\n    font-size: 80%;\n  }\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  sub {\n    bottom: -0.25em;\n  }\n  sup {\n    top: -0.5em;\n  }\n  img {\n    border-style: none;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n  }\n  button,\n  input {\n    overflow: visible;\n  }\n  button,\n  select {\n    text-transform: none;\n  }\n  button,\n  [type='button'],\n  [type='reset'],\n  [type='submit'] {\n    -webkit-appearance: button;\n  }\n  button::-moz-focus-inner,\n  [type='button']::-moz-focus-inner,\n  [type='reset']::-moz-focus-inner,\n  [type='submit']::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n  button:-moz-focusring,\n  [type='button']:-moz-focusring,\n  [type='reset']:-moz-focusring,\n  [type='submit']:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n  legend {\n    box-sizing: border-box;\n    color: inherit;\n    display: table;\n    max-width: 100%;\n    padding: 0;\n    white-space: normal;\n  }\n  progress {\n    vertical-align: baseline;\n  }\n  textarea {\n    overflow: auto;\n  }\n  [type='checkbox'],\n  [type='radio'] {\n    box-sizing: border-box;\n    padding: 0;\n  }\n  [type='number']::-webkit-inner-spin-button,\n  [type='number']::-webkit-outer-spin-button {\n    height: auto;\n  }\n  [type='search'] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px;\n  }\n  [type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit;\n  }\n  details {\n    display: block;\n  }\n  summary {\n    display: list-item;\n  }\n  template {\n    display: none;\n  }\n  [hidden] {\n    display: none;\n  }\n"], ["\n  html {\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n  }\n  body {\n    margin: 0;\n  }\n  main {\n    display: block;\n  }\n  h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n  }\n  hr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n  }\n  pre {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n  a {\n    background-color: transparent;\n  }\n  abbr[title] {\n    border-bottom: none;\n    text-decoration: underline;\n    text-decoration: underline dotted;\n  }\n  b,\n  strong {\n    font-weight: bolder;\n  }\n  code,\n  kbd,\n  samp {\n    font-family: monospace, monospace;\n    font-size: 1em;\n  }\n  small {\n    font-size: 80%;\n  }\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  sub {\n    bottom: -0.25em;\n  }\n  sup {\n    top: -0.5em;\n  }\n  img {\n    border-style: none;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n  }\n  button,\n  input {\n    overflow: visible;\n  }\n  button,\n  select {\n    text-transform: none;\n  }\n  button,\n  [type='button'],\n  [type='reset'],\n  [type='submit'] {\n    -webkit-appearance: button;\n  }\n  button::-moz-focus-inner,\n  [type='button']::-moz-focus-inner,\n  [type='reset']::-moz-focus-inner,\n  [type='submit']::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n  button:-moz-focusring,\n  [type='button']:-moz-focusring,\n  [type='reset']:-moz-focusring,\n  [type='submit']:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n  legend {\n    box-sizing: border-box;\n    color: inherit;\n    display: table;\n    max-width: 100%;\n    padding: 0;\n    white-space: normal;\n  }\n  progress {\n    vertical-align: baseline;\n  }\n  textarea {\n    overflow: auto;\n  }\n  [type='checkbox'],\n  [type='radio'] {\n    box-sizing: border-box;\n    padding: 0;\n  }\n  [type='number']::-webkit-inner-spin-button,\n  [type='number']::-webkit-outer-spin-button {\n    height: auto;\n  }\n  [type='search'] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px;\n  }\n  [type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit;\n  }\n  details {\n    display: block;\n  }\n  summary {\n    display: list-item;\n  }\n  template {\n    display: none;\n  }\n  [hidden] {\n    display: none;\n  }\n"])));
var templateObject_1$2;

var boxSizingReset = css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  &:before,\n  &:after,\n  & *,\n  *:before,\n  *:after {\n    box-sizing: inherit;\n  }\n"], ["\n  box-sizing: border-box;\n  &:before,\n  &:after,\n  & *,\n  *:before,\n  *:after {\n    box-sizing: inherit;\n  }\n"])));
var templateObject_1$1;

var ResetStyles = function () {
    return (jsx(Global, { styles: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", ";\n        ", ";\n        body {\n          ", ";\n        }\n      "], ["\n        ", ";\n        ", ";\n        body {\n          ", ";\n        }\n      "])), reset, normalize, boxSizingReset) }));
};
var templateObject_1;

export { ResetStyles, ThemeProvider, makeStyles, theme, useThemeContext };
//# sourceMappingURL=index.es.js.map
